/**
 * Top 画面: 初期アクセス時のルーティング制御。
 *
 * Firebase Authentication の状態と URL クエリを用いて、
 * Login（会員登録ビュー含む）または FamilyHome へ適切に遷移させます。
 */
import React, { useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import firebase from'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

/**
 * ログイン状態を確認し、適切な画面へ遷移します。
 *
 * - 未ログイン: Login へ遷移します。
 * - ログイン済み: Firestore の `Person/{uid}` から最初の `FamilyID` を取得し、
 *   `FamilyHome/:FamilyID` へ遷移します。
 * - 例外時: Login へフォールバックします。
 *
 * 想定される例外コード/メッセージ:
 * - `not-authenticated`: ユーザーが未認証
 * - `person-not-found`: `Person/{uid}` ドキュメントが存在しない
 * - `familyid-missing`: `Person.FamilyID` が未設定、または `id` 不在
 *
 * @async
 * @function UserStatusCheck
 * @param {function} navigate React Router のナビゲーション関数
 * @returns {Promise<void>} 画面遷移のみを行い、値は返しません
 */
const UserStatusCheck = async (navigate) => {
  try {
    let uid = ''
    let FamilyID = ''
    const unsubscribe = firebase.auth().onAuthStateChanged(async (user) => {
      try {
        if (!user) {
          throw new Error('not-authenticated：ユーザーが未認証です')
        }
        uid = user.uid
        unsubscribe()

        const personSnap = await firebase.firestore().collection('Person').doc(uid).get()
        if (!personSnap.exists) {
          throw new Error('person-not-found：Person ドキュメントが存在しません')
        }
        const data = personSnap.data()
        const firstFamily = data && Array.isArray(data.FamilyID) ? data.FamilyID[0] : undefined
        if (!firstFamily || !firstFamily.id) {
          throw new Error('familyid-missing：FamilyID が未設定、または id 不在です')
        }
        FamilyID = firstFamily.id
        navigate('/FamilyHome/' + FamilyID, { state: { uid } })
      } catch (e) {
        const msg = (e && (e.code || e.message)) ? (e.code || e.message) : e
        console.log('UserStatusCheck error:', msg)
        navigate('/Login')
      }
    })
  } catch (e) {
    const msg = (e && (e.code || e.message)) ? (e.code || e.message) : e
    console.log('UserStatusCheck outer error:', msg)
    navigate('/Login')
  }
}

/**
 * アプリのトップエントリコンポーネント。
 *
 * - クエリ `view=Regist` 指定時は Login の会員登録ビューへ遷移。
 * - それ以外は `UserStatusCheck` を実行し、認証状態に応じて Login または FamilyHome へ遷移。
 *
 * @component
 */
function Top() {
  const navigate = useNavigate();
  const location = useLocation();
  //const [isLogin, setIsLogin] = useState(false)
  useEffect(() => {
    // URL クエリに基づく初期遷移判定。
    // view=Regist の場合、Login 画面の会員登録ビューに遷移する。
    // それ以外は認証状態を確認して適切な画面へ遷移する。
    // URLクエリを使用する
    var query = new URLSearchParams(location.search)
    if(query.get("view") === "Regist"){ //URLが「?view=Regist」の場合は会員登録画面表示を行う。
      navigate('/Login?view=Regist') //ログイン画面上で、会員登録画面に移動する。
    } else {
      UserStatusCheck(navigate) //ログイン状態チェック
    }
  },[navigate, location.search]);

  return (
    <React.Fragment>
    </React.Fragment>
  )
}
export default Top

